import { render, staticRenderFns } from "./privaceAndPolicies.vue?vue&type=template&id=05c31760&"
import script from "./privaceAndPolicies.vue?vue&type=script&lang=js&"
export * from "./privaceAndPolicies.vue?vue&type=script&lang=js&"
import style0 from "./privaceAndPolicies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports